import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getEmployees = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.employee.employees.entries, filter);
};
